import {Pipe, PipeTransform, Injectable} from '@angular/core';

declare const elasticlunr: any;

@Pipe({
  name: 'search'
})

@Injectable()
export class SearchPipe implements PipeTransform {

  /**
   * This returns the object
   * for the search query.
   * @param items
   * @param term
   * @returns {any}
   */

  constructor() {

  }

  transform(items: any, term: string): any {

    if (!term) {
      return items;
    }

    if (!items) {
      return [];
    }

    return items.filter((item: any) => {
      const index: any = elasticlunr(function(this: any)  {
        (this as any).addField('post_name');
        (this as any).addField('post_content');
        (this as any).setRef('post_id');
      });

      index.addDoc(item);

      const resultsTemp = index.search(term.toLowerCase(), {
        fields: {
          'post_name': {boost: 2},
          'post_content': {boost: 1}
        },
        bool: 'AND'
      });

      return resultsTemp.length > 0;
    });
  }
}
